module.exports = {
    "dropzoneLabel": `DropZone`,
    "selectPlaceholder": `Izaberite stavku`,
    "tableResizer": `Promena veli\u{10D}ine`
};


//# sourceMappingURL=sr-SP.main.js.map
